import { ChangeDetectionStrategy, Component, computed, ViewEncapsulation } from '@angular/core';
import { SnackbarToastComponent, SnackbarToastVariant } from '@joii/design-system';
import { LucideCircleCheck, LucideCircleX, LucideInfo, LucideIcon, LucideTriangleAlert } from '@lucide/angular';
import { Toast } from 'ngx-toastr';
import { mapToastTypeToVariant } from './map-toast-type-to-variant';

const VARIANT_ICONS: Record<SnackbarToastVariant, LucideIcon> = {
  success: LucideCircleCheck,
  error: LucideCircleX,
  warning: LucideTriangleAlert,
  info: LucideInfo,
  highlight: LucideInfo,
};

@Component({
  selector: 'app-joii-snackbar-toastr',
  template: `
    <joii-snackbar-toast [variant]="variant()" [message]="displayMessage()" [icon]="icon()" (closed)="remove()" />
  `,
  styles: `
    .toast-container .ngx-toastr.joii-snackbar-toastr {
      display: block;
      background-color: transparent !important;
      background-image: none !important;
      box-shadow: none !important;
      padding: 0 !important;
      width: min(100%, 28rem);
    }
  `,
  imports: [SnackbarToastComponent],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JoiiSnackbarToastrComponent extends Toast {
  readonly variant = computed(() => mapToastTypeToVariant(this.toastPackage.toastType));
  readonly icon = computed(() => VARIANT_ICONS[this.variant()]);
  readonly displayMessage = computed(() => this.message() || this.title() || '');
}
